import { Card, BaseCardsClient } from "@core/types";

class CardsClient extends BaseCardsClient {
  async getCards(): Promise<Card[]> {
    return new Promise((resolve, reject) => {
      resolve([]);
    });
  }
  async deleteCard(variables: { id: string }): Promise<any> {
    return new Promise(() => {});
  }
}

export default CardsClient;
